import { Box, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import QRCode from "../../../../../../Images/QRCode.png";
import QuickTixLogo from "../../../../../../Images/GX_Logo_Black_No_Bg.png";
import QrCode from "../../../../../../Images/qrCode1.png";
import moment from "moment";

function Ticket7({ ticket, ChangeColor, type, image, bookerName, navigator }) {
  const qrCodeData = ticket?.qrCode || "";
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Paper
      elevation={0}
      sx={{
        height: { xs: "200px", md: "100%" },
        display: "flex",
        border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
        boxShadow: pevSelected
          ? "0 4px 12px rgba(74, 144, 226, 0.5)"
          : "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.1s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          border: "1px solid #4A90E2",
          borderRadius: "1px",
        },
        backgroundColor: ChangeColor
          ? ChangeColor
          : ticket?.bgColor
          ? ticket?.bgColor
          : "white",
      }}
    >
      <Typography
        flex={1}
        variant="h6"
        Wrap
        component="div"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
          color: "#191919",
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          fontFamily: "Lato",

          borderLeft: "1px solid #595959",
        }}
        textAlign={"center"}
      >
        {ticket?.code}
      </Typography>

      <Box
        flex={2}
        alignItems={"center"}
        sx={{
          display: "flex",
          borderRight: "1px solid #595959",
          flexDirection: "column",
          position: "relative",
        }}
        justifyContent={"center"}
        px={"0.2em"}
      >
        {navigator === "ct" ? (
          <></>
        ) : !qrCodeData ? (
          <img
            src={QrCode}
            alt="qr"
            style={{
              width: "100%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        ) : (
          <img
            src={ticket?.qrCode || QrCode}
            alt="QR"
            style={{
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        )}
        <img
          src={QuickTixLogo}
          alt="QR"
          style={{
            position: "absolute",
            maxWidth: "50%",
            height: "auto",
            maxHeight: "40px",
            objectFit: "contain",
            bottom: 7,
          }}
        />
      </Box>

      <Stack
        flex={12}
        direction={"row"}
        pb={"1.8rem"}
        justifyContent={"space-between"}
        pl={{ xs: "0.3em", sm: "2em", md: "1.5rem" }}
        pr={{ xs: "0.3em", sm: "2em", md: "1.5rem" }}
      >
        <Stack mt={2.5} flex={3}>
          <Stack>
            <img
              alt="Logo"
              src={image ? image : QuickTixLogo}
              style={{
                width: "40%",
                maxWidth: "80%",
                height: "auto",
                maxHeight: "80px",
                objectFit: "contain",
              }}
            />
          </Stack>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: {
                xs: "0.8rem",
                sm: "2rem",
                md: "2rem",
                lg: "2.5rem",
              },
              color: "black",
              fontFamily: "Bebas Neue",
            }}
            ml={0.5}
          >
            {ticket?.title}
          </Typography>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "0.6rem", sm: "0.875rem" },
              color: "#191919",
              fontFamily: "Lato",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "wrap",
              maxWidth: "180px",
            }}
            ml={0.5}
            mt={0}
          >
            {ticket?.location}
          </Typography>
        </Stack>
        <Stack mt={3} alignItems={"flex-end"} flex={2}>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: "1rem",
              whiteSpace: "nowrap",
              color: "#191919",
              fontFamily: "Bebas Neue",
              minWidth: "30px",
            }}
            ml={1}
          >
            ${" "}
            {ticket?.price != null && ticket?.price !== ""
              ? ticket?.ticketPrices
                ? Object.values(ticket?.ticketPrices)[0]
                : Number(ticket?.price) === 0
                ? "Free"
                : Number(ticket?.price) % 1 === 0
                ? Number(ticket?.price).toFixed(0)
                : ticket.price
              : "211"}
          </Typography>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 400,
              fontSize: { xs: "0.5rem", sm: "0.6rem" },
              color: "#737373",
              fontFamily: "Lato",
            }}
            ml={1}
            mt={3}
          >
            {ticket?.ticketName ? ticket?.ticketName : "Ticket"}
          </Typography>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 600,
              fontSize: { xs: "0.55rem", sm: "0.8rem" },
              color: "#191919",
              textAlign: "end",
              fontFamily: "Lato",
              minWidth: "50px",
            }}
            ml={1}
            mt={0}
          >
            {bookerName}
          </Typography>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "0.5rem", sm: "0.7rem" },
              color: "#191919",
              textAlign: "end",
              fontFamily: "Lato",
            }}
            ml={1}
            mt={0.5}
          >
            {moment(ticket?.date).format("MM/DD/YYYY")}
          </Typography>
          <Typography
            variant="h6"
            Wrap
            component="div"
            sx={{
              fontWeight: 500,
              fontSize: "0.7rem",
              color: "#191919",
              textAlign: "end",
              fontFamily: "Lato",
            }}
            ml={1}
          >
            {ticket?.time}
          </Typography>
        </Stack>
      </Stack>

      <Stack
        flex={1}
        variant="h6"
        Wrap
        component="div"
        sx={{
          fontWeight: "bold",
          fontSize: {
            xs: "2rem",
            sm: "2rem",
            md: "2rem",
            lg: "3rem",
          },
          color: "#191919",
          writingMode: "vertical-rl",
          transform: "rotate(180deg)",
          fontFamily: "Bebas Neue",
          padding: 0,
          margin: 0,
          borderRight: "1px solid #595959",
        }}
        textAlign={"center"}
      >
        {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
      </Stack>
    </Paper>
  );
}

export default Ticket7;
